var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,12a5,5,0,1,0-5,5A5,5,0,0,0,17,12Zm-5,3a3,3,0,1,1,3-3A3,3,0,0,1,12,15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87,19.37h0v.33a.21.21,0,0,1-.21.22H4.3a.22.22,0,0,1-.22-.22V15.34a.22.22,0,0,1,.22-.22H7.58A5.4,5.4,0,0,1,6.68,13H4.3A2.31,2.31,0,0,0,2,15.34V19.7A2.3,2.3,0,0,0,4.3,22H11V17.31a5.5,5.5,0,0,1-2.09-.89Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.69,2H13V6.69a5.45,5.45,0,0,1,2.08.89V4.63h0V4.3a.22.22,0,0,1,.22-.22h4.35a.22.22,0,0,1,.22.22v4h0v.33a.21.21,0,0,1-.22.21H16.41a5.36,5.36,0,0,1,.9,2.09H22V4.3A2.32,2.32,0,0,0,19.69,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.69,13H17.31a5.25,5.25,0,0,1-.9,2.08h3.28a.22.22,0,0,1,.22.22v.33h0v4a.22.22,0,0,1-.22.22H15.34a.22.22,0,0,1-.22-.22v-.33h0V16.42a5.45,5.45,0,0,1-2.08.89V22h6.65A2.32,2.32,0,0,0,22,19.7V13H19.69Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.3,11H6.68a5.51,5.51,0,0,1,.9-2.09H4.3a.22.22,0,0,1-.22-.21V8.33h0v-4a.22.22,0,0,1,.22-.22H8.66a.21.21,0,0,1,.21.22v.33h0v3A5.5,5.5,0,0,1,11,6.69V2H4.3A2.3,2.3,0,0,0,2,4.3V11H4.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakrooms);
export default __webpack_public_path__ + "static/media/breakrooms.e81a022a784d80c85f29f96e8910c7c5.svg";
export { ForwardRef as ReactComponent };